import { iRequest } from '../../utils/requestutil';

export async function queryConfig(payload) {
  return iRequest(
    `/iwms-openapi/api/ignoreStockBinUsageConfig/queryConfig?interfaceConfigUuid=${payload.interfaceConfigUuid}`,
    {
      method: 'GET',
    },
  );
}

export async function queryField(payload) {
  return iRequest(`/iwms-openapi/api/ignoreStockBinUsageConfig/queryField`, {
    method: 'GET',
  });
}

export async function save(payload) {
  return iRequest(
    `/iwms-openapi/api/ignoreStockBinUsageConfig?companyUuid=${payload.companyUuid}&interfaceConfigUuid=${payload.interfaceConfigUuid}`,
    {
      method: 'POST',
      body: payload.binUsages,
    },
  );
}
